var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame212(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#20A3BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 22.36C21.0867 19.9067 22.0333 17.9867 23.74 16.6C25.4467 15.2133 27.66 14.52 30.38 14.52C32.1933 14.52 33.7533 14.8533 35.06 15.52C36.3933 16.16 37.3933 17.04 38.06 18.16C38.7533 19.28 39.1 20.5467 39.1 21.96C39.1 23.6133 38.62 25.04 37.66 26.24C36.7267 27.44 35.5 28.2133 33.98 28.56V28.76C35.7133 29.1867 37.0867 30.0267 38.1 31.28C39.1133 32.5333 39.62 34.1733 39.62 36.2C39.62 37.72 39.2733 39.0933 38.58 40.32C37.8867 41.52 36.8467 42.4667 35.46 43.16C34.0733 43.8533 32.4067 44.2 30.46 44.2C27.6333 44.2 25.3133 43.4667 23.5 42C21.6867 40.5067 20.6733 38.4 20.46 35.68H23.98C24.1667 37.28 24.82 38.5867 25.94 39.6C27.06 40.6133 28.5533 41.12 30.42 41.12C32.2867 41.12 33.7 40.64 34.66 39.68C35.6467 38.6933 36.14 37.4267 36.14 35.88C36.14 33.88 35.4733 32.44 34.14 31.56C32.8067 30.68 30.7933 30.24 28.1 30.24H27.18V27.2H28.14C30.5933 27.1733 32.4467 26.7733 33.7 26C34.9533 25.2 35.58 23.9733 35.58 22.32C35.58 20.9067 35.1133 19.7733 34.18 18.92C33.2733 18.0667 31.9667 17.64 30.26 17.64C28.6067 17.64 27.2733 18.0667 26.26 18.92C25.2467 19.7733 24.6467 20.92 24.46 22.36H20.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame212);
export default __webpack_public_path__ + "static/media/Frame 21 (2).c3148e7352e990fef700232b8e36aa84.svg";
export { ForwardRef as ReactComponent };